import {r as v} from '@theme/theme-sections';
import {i as m} from '@theme/currency-selector';
const i = {
    navToggle: '.nav-toggle',
    navClose: '.nav-close',
    navOverlay: '.fader--nav',
    navItemHasChild: '.nav__item--has-child',
    navLink: '.nav__item--toggle',
    subnavLink: '.subnav__item--toggle',
    navDropdown: '.nav__dropdown',
    activeDropdownLinks: '.nav__item--has-child.is-expanded',
    openNavToggles: '.nav__item--has-child.is-expanded .nav__item--toggle',
    preExpandedDropdowns: '[data-pre-expanded]',
  },
  s = {
    isExpanded: 'is-expanded',
    isCollapsed: 'is-collapsed',
    dropdownIsActive: 'dropdown-is-active',
    menuIsExpanded: 'menu-is-expanded',
    mobileMenuActive: 'mobile-menu-active',
    headerTransparent: 'header--transparent',
    headerSticky: 'header--sticky',
    headerPinned: 'header--pinned',
  },
  u = 'header';
var c, l, h;
const p =
    ((h = (l = (c = window.Shopify) == null ? void 0 : c.theme) == null ? void 0 : l.sections) == null
      ? void 0
      : h.registered) || {},
  L = typeof p[u] > 'u';
L &&
  v(u, {
    closeTimeoutId: null,
    hoverTimeoutDuration: 200,
    onLoad() {
      this.setHeaderHeightVar(),
        this.setAnnouncementBarHeightVar(),
        this.container.querySelector(i.navToggle).addEventListener('click', this.btnMenuClickToggleHandler.bind(this)),
        this.container.querySelector(i.navClose).addEventListener('click', this.btnMenuClickCloseHandler.bind(this));
      const t = window.matchMedia(`(min-width: ${window.theme.breakpoints.lg}px)`),
        a = (d) => {
          this.handleResize(),
            d.matches
              ? (this.calculateNavDropdownMaxSize(), this.addDesktopHoverListeners())
              : (this.removeDesktopHoverListeners(), this.addMobileClickListeners());
        };
      typeof (t == null ? void 0 : t.addEventListener) == 'function'
        ? t.addEventListener('change', a.bind(this))
        : t.addListener(a.bind(this)),
        t.matches
          ? (this.calculateNavDropdownMaxSize(), this.addDesktopHoverListeners())
          : this.addMobileClickListeners(),
        window.addEventListener('resize', () => {
          this.setAnnouncementBarHeightVar(),
            this.setHeaderHeightVar(),
            t.matches && this.calculateNavDropdownMaxSize();
        }),
        this.configurePreExpandedDropdowns();
      const o = document.querySelector(i.navOverlay);
      o == null || o.addEventListener('click', this.btnMenuClickCloseHandler.bind(this));
      const r = this.container.querySelectorAll(i.subnavLink);
      r == null ||
        r.forEach((d) => (d == null ? void 0 : d.addEventListener('click', this.subnavLinkClickHandler.bind(this)))),
        m(this.container),
        this.headerTransparencyObserver();
    },
    calculateNavDropdownMaxSize() {
      window.requestAnimationFrame(() => {
        const n = this.container,
          e = n.offsetHeight;
        n.querySelectorAll(i.navDropdown).forEach((a) => a.style.setProperty('--header-height', `${e}px`));
      });
    },
    setHeaderHeightVar() {
      window.requestAnimationFrame(() => {
        const n = this.container.offsetHeight;
        document.documentElement.style.setProperty('--header-height', `${n}px`);
      });
    },
    setAnnouncementBarHeightVar() {
      window.requestAnimationFrame(() => {
        const n = document.querySelector('.announcement-bar');
        if (!n) return;
        const e = n.offsetHeight;
        document.documentElement.style.setProperty('--announcement-bar-height', `${e}px`);
      });
    },
    handleResize() {
      document.body.classList.contains(s.menuIsExpanded) &&
        window.matchMedia(`(min-width: ${window.theme.breakpoints.lg}px)`).matches &&
        this.btnMenuClickCloseHandler(),
        this.collapseDropdown(),
        this.setHeaderHeightVar(),
        this.setAnnouncementBarHeightVar();
    },
    collapseDropdown() {
      const n = this.container.querySelectorAll(i.activeDropdownLinks),
        e = this.container.querySelectorAll(i.openNavToggles);
      document.body.classList.remove(s.dropdownIsActive),
        n.forEach((t) => {
          t.classList.remove(s.isExpanded), t.classList.add(s.isCollapsed);
        }),
        e.forEach((t) => t.setAttribute('aria-expanded', !1));
    },
    btnMenuClickToggleHandler() {
      document.body.classList.contains(s.menuIsExpanded)
        ? this.btnMenuClickCloseHandler()
        : this.btnMenuClickOpenHandler();
    },
    btnMenuClickOpenHandler() {
      document.body.classList.add(s.menuIsExpanded),
        window.matchMedia(`(min-width: ${window.theme.breakpoints.lg}px)`).matches ||
          document.getElementsByTagName('html')[0].classList.add(s.mobileMenuActive),
        this.container.querySelectorAll(i.activeDropdownLinks).forEach((t) => {
          t.hasAttribute('data-pre-expanded') ||
            (t.classList.remove(s.isExpanded), setTimeout(() => t.classList.add(s.isCollapsed), 200));
        });
    },
    btnMenuClickCloseHandler() {
      document.body.classList.remove(s.dropdownIsActive),
        document.body.classList.remove(s.menuIsExpanded),
        window.matchMedia(`(min-width: ${window.theme.breakpoints.lg}px)`).matches ||
          document.getElementsByTagName('html')[0].classList.remove(s.mobileMenuActive),
        this.container.querySelectorAll(i.activeDropdownLinks).forEach((t) => {
          t.classList.remove(s.isExpanded), t.classList.add(s.isCollapsed);
        });
    },
    navLinkClickHandler(n) {
      n.preventDefault();
      const e = n.currentTarget.parentElement,
        t = n.currentTarget;
      return (
        this.container.querySelectorAll(i.activeDropdownLinks).forEach((a) => {
          var o;
          if (a !== e) {
            if (a.hasAttribute('data-pre-expanded')) return;
            a.classList.remove(s.isExpanded),
              a.classList.add(s.isCollapsed),
              (o = a.querySelector(i.navLink)) == null || o.setAttribute('aria-expanded', 'false');
          }
        }),
        e.classList.contains(s.isExpanded)
          ? (t.setAttribute('aria-expanded', !1), e.classList.remove(s.isExpanded), e.classList.add(s.isCollapsed))
          : (e.classList.remove(s.isCollapsed), e.classList.add(s.isExpanded), t.setAttribute('aria-expanded', !0)),
        !0
      );
    },
    subnavLinkClickHandler(n) {
      n.preventDefault();
      const e = n.currentTarget.parentElement,
        t = n.currentTarget;
      return (
        e.classList.contains(s.isExpanded)
          ? (t.setAttribute('aria-expanded', !1), e.classList.remove(s.isExpanded), e.classList.add(s.isCollapsed))
          : (e.classList.remove(s.isCollapsed), e.classList.add(s.isExpanded), t.setAttribute('aria-expanded', !0)),
        !0
      );
    },
    headerTransparencyObserver() {
      var a;
      if (!this.container.classList.contains('header--sticky')) return;
      const n = this.container.classList.contains(s.headerTransparent),
        e = (a = document.getElementById('MainContent')) == null ? void 0 : a.firstElementChild;
      if (!n || !e.classList.contains('hero-slider-section')) return;
      new IntersectionObserver(
        (o) => {
          o.forEach((r) => {
            r.isIntersecting
              ? this.container.classList.remove(s.headerPinned)
              : this.container.classList.add(s.headerPinned);
          });
        },
        {rootMargin: `${-1 * this.container.offsetHeight}px`}
      ).observe(e);
    },
    addDesktopHoverListeners() {
      this.removeMobileClickListeners(),
        this.container.querySelectorAll(i.navItemHasChild).forEach((e) => {
          const t = e.querySelector(i.navDropdown),
            a = e.querySelector(i.navLink);
          e.addEventListener('mouseenter', this.navItemMouseEnterHandler.bind(this)),
            e.addEventListener('mouseleave', this.navItemMouseLeaveHandler.bind(this)),
            t &&
              (t.addEventListener('mouseenter', this.dropdownMouseEnterHandler.bind(this)),
              t.addEventListener('mouseleave', this.dropdownMouseLeaveHandler.bind(this))),
            a && a.addEventListener('click', this.preventLinkDefault);
        });
    },
    removeDesktopHoverListeners() {
      this.container.querySelectorAll(i.navItemHasChild).forEach((e) => {
        const t = e.querySelector(i.navDropdown),
          a = e.querySelector(i.navLink);
        e.removeEventListener('mouseenter', this.navItemMouseEnterHandler.bind(this)),
          e.removeEventListener('mouseleave', this.navItemMouseLeaveHandler.bind(this)),
          t &&
            (t.removeEventListener('mouseenter', this.dropdownMouseEnterHandler.bind(this)),
            t.removeEventListener('mouseleave', this.dropdownMouseLeaveHandler.bind(this))),
          a && a.removeEventListener('click', this.preventLinkDefault);
      });
    },
    addMobileClickListeners() {
      this.removeDesktopHoverListeners(),
        this.container.querySelectorAll(i.navLink).forEach((e) => {
          e.hasAttribute('data-mobile-click-bound') ||
            (e.addEventListener('click', this.navLinkClickHandler.bind(this)),
            e.setAttribute('data-mobile-click-bound', 'true'));
        });
    },
    removeMobileClickListeners() {
      this.container.querySelectorAll(i.navLink).forEach((e) => {
        e.removeEventListener('click', this.navLinkClickHandler.bind(this)),
          e.removeAttribute('data-mobile-click-bound');
      });
    },
    preventLinkDefault(n) {
      n.preventDefault();
    },
    navItemMouseEnterHandler(n) {
      clearTimeout(this.closeTimeoutId);
      const e = n.currentTarget;
      if (
        (this.container.querySelectorAll(i.activeDropdownLinks).forEach((t) => {
          t !== e && this.closeNavItemDropdown(t);
        }),
        !e.classList.contains(s.isExpanded))
      ) {
        const t = e.querySelector(i.navLink);
        e.classList.remove(s.isCollapsed),
          e.classList.add(s.isExpanded),
          document.body.classList.add(s.dropdownIsActive),
          t == null || t.setAttribute('aria-expanded', 'true'),
          this.container.classList.add('subnav-active');
      }
    },
    navItemMouseLeaveHandler(n) {
      clearTimeout(this.closeTimeoutId);
      const e = n.currentTarget;
      this.closeTimeoutId = setTimeout(() => {
        this.closeNavItemDropdown(e);
      }, this.hoverTimeoutDuration);
    },
    dropdownMouseEnterHandler() {
      clearTimeout(this.closeTimeoutId);
    },
    dropdownMouseLeaveHandler(n) {
      const e = n.currentTarget.closest(i.navItemHasChild);
      e &&
        (clearTimeout(this.closeTimeoutId),
        (this.closeTimeoutId = setTimeout(() => {
          this.closeNavItemDropdown(e);
        }, this.hoverTimeoutDuration)));
    },
    closeNavItemDropdown(n) {
      if (n && n.classList.contains(s.isExpanded)) {
        const e = n.querySelector(i.navLink);
        e == null || e.setAttribute('aria-expanded', 'false'),
          n.classList.remove(s.isExpanded),
          n.classList.add(s.isCollapsed),
          this.container.querySelector(i.activeDropdownLinks) ||
            (document.body.classList.remove(s.dropdownIsActive), this.container.classList.remove('subnav-active'));
      }
    },
    configurePreExpandedDropdowns() {
      const n = this.container.querySelectorAll(i.preExpandedDropdowns);
      if (!(n != null && n.length)) return;
      const e = window.matchMedia(`(min-width: ${window.theme.breakpoints.lg}px)`).matches;
      n.forEach((t) => {
        t.style.removeProperty('display'), e && (t.classList.remove(s.isExpanded), t.classList.add(s.isCollapsed));
      });
    },
  });
